import { addDays, todayIso } from './FieldOpsKit'
import { placeInCity } from './geo'

/**
 * Demo list of Altitude stores with no route in Sage ("SinRuta"). The count (171) is the real figure on 2026-10-28;
 * the names, cities and dates are invented.
 */
const A = ['La Bendición', 'El Gran Mercado', 'Mi Rancho', 'Los Compadres', 'La Joya', 'El Maizal', 'Santa Cruz', 'La Nopalera', 'El Cántaro', 'Las Américas', 'San Miguel', 'La Parroquia', 'El Tianguis', 'Doña Lupe', 'Villa Hermosa', 'El Charro']
const B = ['Market', 'Supermercado', 'Tienda', 'Mercado', 'Food Mart', 'Abarrotes', 'Carnicería']
const CITIES = ['Atlanta, GA', 'Birmingham, AL', 'Huntsville, AL', 'Gadsden, AL', 'Athens, GA', 'Macon, GA', 'Augusta, GA', 'Savannah, GA', 'Anniston, AL', 'Dothan, AL', 'Albany, GA', 'Chattanooga, TN', 'Knoxville, TN', 'Rome, GA', 'Tuscaloosa, AL', 'Montgomery, AL', 'Gainesville, GA', 'Valdosta, GA', 'Marietta, GA', 'Albertville, AL']
const REPS_LIST = ['RT', 'JR', 'JC', 'JC', 'JR']

const seeded = (seed) => { let s = seed; return () => { s = (s * 1664525 + 1013904223) % 4294967296; return s / 4294967296 } }

export const UNROUTED_COUNT = 171

export const buildUnrouted = () => {
    const rnd = seeded(555)
    const today = todayIso()
    const out = []
    for (let i = 0; i < UNROUTED_COUNT; i++) {
        const last = rnd() < 0.18 ? null : addDays(today, -Math.floor(rnd() * 240))
        const city = CITIES[Math.floor(rnd() * CITIES.length)]
        const place = placeInCity(city, rnd)
        out.push({
            id: 'u' + (i + 1),
            name: B[Math.floor(rnd() * B.length)] + ' ' + A[Math.floor(rnd() * A.length)] + (i > 40 ? ' #' + (1 + (i % 9)) : ''),
            city: city, lat: place.lat, lng: place.lng, address: (100 + Math.floor(rnd() * 8900)) + ' ' + ['Main St', 'Broad St', 'Oak Ave', 'Highway 11', 'Church St'][Math.floor(rnd() * 5)], phone: '(555) 010-' + String(1000 + Math.floor(rnd() * 8999)),
            rep: REPS_LIST[Math.floor(rnd() * REPS_LIST.length)],
            lastOrder: last,
            sales90: last ? Math.round(rnd() * 14000) : 0,
        })
    }
    return out
}
